import { isModuleEnabled, SystemConfiguration } from 'app/interfaces/Config';
import { QualityChecklistStatus } from 'app/interfaces/QualityChecklist';
import { UserType } from 'app/interfaces/User';
import { StateWorkOrder, WorkOrdersFilters } from 'app/interfaces/workOrder';

interface QualityCountRow {
  qualityStatus?: QualityChecklistStatus | null;
  stateWorkOrder: StateWorkOrder;
}

export const isValidatedByQuality = (row: QualityCountRow): boolean =>
  row.qualityStatus === QualityChecklistStatus.Approved &&
  row.stateWorkOrder === StateWorkOrder.PendingToValidate;

export const canUseQualityQuickFilters = (
  userType?: UserType,
  config?: SystemConfiguration
): boolean =>
  isModuleEnabled(config, 'isQualityValidation') &&
  (userType === UserType.Maintenance || userType === UserType.Quality);

export type QualityQuickFilter = 'pending' | 'validated';

export const toggleQualityQuickFilter = (
  filters: WorkOrdersFilters,
  quick: QualityQuickFilter
): WorkOrdersFilters => {
  if (quick === 'pending') {
    return {
      ...filters,
      pendingQuality: !filters.pendingQuality,
      qualityValidated: false,
    };
  }
  return {
    ...filters,
    qualityValidated: !filters.qualityValidated,
    pendingQuality: false,
  };
};

export const shouldShowQualityChip = (
  count: number | undefined,
  active: boolean
): boolean => active || (count !== undefined && count > 0);

export const resolveQuickChipCount = (
  count: number | undefined
): number | undefined =>
  count === undefined || !Number.isFinite(count) ? undefined : count;
